export default "__VITE_ASSET__38393cb0__"